import { render } from "./FreeLabel.vue?vue&type=template&id=f8c1ea64"
import script from "./FreeLabel.vue?vue&type=script&lang=js"
export * from "./FreeLabel.vue?vue&type=script&lang=js"

import "./FreeLabel.vue?vue&type=style&index=0&id=f8c1ea64&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__